enum AddressType {
    Billing = 'billing',
    Shipping = 'shipping',
}

export default AddressType;
